import { allCoursesForForm } from "./constant";
import "../../shared/styles/index.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { CreateStudentEnquirey } from "../../api/Global";

const Form = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [course, setCourse] = useState("");

  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [cityError, setCityError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [courseError, setCourseError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setNameError("");
    setMobileError("");
    setCityError("");
    setEmailError("");
    setCourseError("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const indianMobileRegex = /^[6-9]\d{9}$/;

    if (!name.trim()) return setNameError("Name is required!");

    if (!email.trim()) return setEmailError("Email is required!");
    if (!emailRegex.test(email.trim()))
      return setEmailError(
        "Please provide a correct email, invalid email format!"
      );

    if (!mobile.trim()) return setMobileError("Mobile number is required!");
    if (!indianMobileRegex.test(mobile.trim()))
      return setMobileError("Invalid mobile number format");
    if (!city.trim()) return setCityError("City is required!");

    if (!course.trim()) return setCourseError("Course is required!");

    const mathAnswer = 14;

    const data = {
      name,
      email,
      mobile,
      email,
      city,
      course,
      mathAnswer,
    };
    try {
      const response = await CreateStudentEnquirey(data);

      if (response?.data?.status == true) {
        navigate("/Thank_You");
        setName("");
        setEmail("");
        setMobile("");
        setCity("");
        setCourse("");
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <div className="form-container">
      <p className="faq-title">Reach out to us</p>

      <div>
        <label htmlFor="">
          Your Name <span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="text"
          placeholder="Name"
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
        {nameError && <p className="text-danger">{nameError}</p>}
      </div>
      <div className="form-each-conatiner">
        <label htmlFor="">
          Your Email Id <span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="email"
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />
        {emailError && <p className="text-danger">{emailError}</p>}
      </div>
      <div className="form-each-conatiner">
        <label htmlFor="">
          Mobile Number <span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="text"
          placeholder="Mobile Number"
          onChange={(e) => setMobile(e.target.value)}
          value={mobile}
        />
        {mobileError && <p className="text-danger">{mobileError}</p>}
      </div>
      <div className="form-each-conatiner">
        <label htmlFor="">
          City <span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="text"
          placeholder="City"
          onChange={(e) => setCity(e.target.value)}
          value={city}
        />
        {cityError && <p className="text-danger">{cityError}</p>}
      </div>
      <div className="form-each-conatiner">
        <label htmlFor="">
          Course <span style={{ color: "red" }}>*</span>
        </label>
        <select
          name=""
          id=""
          onChange={(e) => setCourse(e.target.value)}
          value={course}
        >
          {allCoursesForForm.map((course) => (
            <option value={course}>{course}</option>
          ))}
        </select>
        {courseError && <p className="text-danger">{courseError}</p>}
      </div>
      <button onClick={handleSubmit}>Submit </button>
    </div>
  );
};

export default Form;
